import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ListaPrenotazioniComponent } from '../appuntamenti/lista-prenotazioni/lista-prenotazioni.component';
import { HomeComponent } from '../home/home.component';
import { AreapersonaleComponent } from './areapersonale/areapersonale.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {path: 'private', component: AreapersonaleComponent, data:{pageTitle: 'home.titleAreaPersonale'}}
    ]),
  ],
})
export class EntityRoutingModule {}
